import Vue from 'vue'
// import * as Constants from '@/constant'
import * as Lodash from 'lodash'

export const fn = {
  handleResponse({rootState, resolve, reject, res}) {
    // debugger
    if (res.success) {
      this.resolveAction(resolve, res)
    } else {
      this.rejectAction(rootState, reject, res)
    }
  },
  resolveAction(resolve, res) {
    resolve(res.data)
  },
  rejectAction(rootState, reject, res) {
    // rootState.reqLog.push(res)
    reject(res)
  }
}

export const actions = {
  refreshListItem({ state, dispatch, rootState, commit }, { index, key, record, action, codeParam }) {
    commit('updateListItem', { record, index, action })
  }
}

export const mutations = {
  updateSearchedForm(state) {
    state.searchedForm = { ...state.searchInfo }
  },
  updateInfo(state, value) {
    state.info = { ...value }
  },
  removeListItem(state, { index }) {
    state.list.splice(index, 1)
  },
  updateListItem(state, { record, index, action }) { // 这里不再需要key这个参数了
    if (state.list && index >= 0 && index < state.list.length) {
      Vue.set(state.list, index, Lodash.assign({}, state.list[index], record, { 'updatedAction': action }))
      console.debug('state.list[' + index + '] = ', state.list[index])
    }
  }
}

// export default {
//     formatI18nValues: ($t, prefix, value) => {
//         return value ? $t(prefix + value) : null
//     }
// }



// WEBPACK FOOTER //
// ./src/utils/StoreUtils.js